export const BASE_THEME = {
  spacing: 4,
};
